import React from 'react';
import loadable from '@loadable/component';
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { useAnalytics, useAnalyticsAttributes } from './hooks';
const ReactMarkdown = loadable(() => import('react-markdown'));
export function Markdown({ children = '', links = true }) {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (React.createElement(ReactMarkdown
    /*
      Add `notranslate` class to patch Google Translate / React bug
      Documentation: https://developers.google.com/search/blog/2008/10/helping-you-break-language-barrier

      More context about the bug: https://github.com/facebook/react/issues/11538
      Alternative fix from React team: https://github.com/facebook/react/issues/11538#issuecomment-417504600
    */
    , { 
        /*
          Add `notranslate` class to patch Google Translate / React bug
          Documentation: https://developers.google.com/search/blog/2008/10/helping-you-break-language-barrier
  
          More context about the bug: https://github.com/facebook/react/issues/11538
          Alternative fix from React team: https://github.com/facebook/react/issues/11538#issuecomment-417504600
        */
        className: "notranslate", components: {
            a: links
                ? ({ href, title, children, node }) => {
                    var _a, _b, _c, _d, _e;
                    const uuid = [
                        (_a = node.children[0]) === null || _a === void 0 ? void 0 : _a.type,
                        (_c = (_b = node.children[0]) === null || _b === void 0 ? void 0 : _b.position) === null || _c === void 0 ? void 0 : _c.start.line,
                        (_e = (_d = node.children[0]) === null || _d === void 0 ? void 0 : _d.position) === null || _e === void 0 ? void 0 : _e.start.column,
                        0
                    ].join('-');
                    return (React.createElement(Anchor, { "data-uuid": uuid, href: href, onClick: () => sendTrackEvent('clickedAnchor', Object.assign(Object.assign({ eventContainer: 'markdown' }, analyticsAttributes), { event: 'clicked', eventComponent: 'link', href, label: children[0], title,
                            uuid })), title: title }, children));
                }
                : ({ children }) => React.createElement(React.Fragment, null, children)
        } }, children));
}
//# sourceMappingURL=Markdown.js.map